import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DateHelperService } from 'src/app/core/helpers/date-helper/date-helper.service';
import { StringHelperService } from 'src/app/core/helpers/string-helper/string-helper.service';
import { Appointment } from 'src/app/core/models/appointment.model';
import { DataTabSection } from 'src/app/core/models/data-tab-section.model';
import { StatusPatchData } from 'src/app/core/models/status-patch-data.model';
import { ClientConfigurationService } from 'src/app/core/client-configuration/client-configuration.service';
import { ConfigSetting } from 'src/app/core/models/config-settings.model';


@Component({
	selector: 'app-appointment-list-item',
	templateUrl: './appointment-list-item.component.html',
	styleUrls: ['./appointment-list-item.component.scss'],
})
export class AppointmentListItemComponent implements OnInit {

	@Input()
	appointment: Appointment;

	@Input()
	dataTabPreview = null as DataTabSection;

	@ViewChild('preview', { static: false })
	preview: ElementRef;
	previewMaxHeight = 0;

	@Output()
	statusChange = new EventEmitter<{ statusPatchData: StatusPatchData, openClearCodeTab: boolean }>();

	isExpanded = false;
	wc2Url: string;
	ticketStructureLink: number;
	showInWc2: boolean = false;

	constructor(
		private dateHelperService: DateHelperService,
		private stringHelperService: StringHelperService,
		private router: Router,
		private clientConfig: ClientConfigurationService,
	) { }

	async ngOnInit() {
		const setting = (await this.clientConfig.getSetting("WC2_URL"));
		this.ticketStructureLink = this.appointment.ticketStructureLink;

		if (setting != null && this.ticketStructureLink > 0) {
			const structureId = this.ticketStructureLink;
			this.wc2Url = `${setting.value}webconsole/(draweroutlet:pickview/dbo_Structure/${structureId})`;
			this.showInWc2 = true;
		}
	}

	onClickWorkTicket() {
		this.router.navigate(['appointments', this.appointment.id, 'details']);
	}

	getClockTime(dateTime: string) {
		dateTime = this.dateHelperService.interperetDateTimeAsLocal(dateTime);
		const date = new Date(dateTime);
		return `${this.dateHelperService.getClockTime(date)}`;
	}

	truncate(value: string, limit: number): string {
		return this.stringHelperService.truncate(value, limit);
	}

	toggleShowMore() {
		if (!this.dataTabPreview) {
			return;
		}

		this.isExpanded = !this.isExpanded;

		if (this.previewMaxHeight === 0) {
			this.previewMaxHeight = this.preview.nativeElement.scrollHeight;
		} else {
			this.previewMaxHeight = 0;
		}
	}
}
